module.exports = __webpack_public_path__ + "assets/c553f021dc11ebf13f578a523d67a8f7.mp3";